import { render } from "./GeneralInfo.vue?vue&type=template&id=88a4a9b2&ts=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=ts"
export * from "./GeneralInfo.vue?vue&type=script&lang=ts"

import "./GeneralInfo.vue?vue&type=style&index=0&id=88a4a9b2&lang=scss"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QAvatar,QIcon});
